import React, { useState } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import CustomLogoRenderer from '@/components/CustomLogo/CustomLogoRenderer';
import { CustomOrgProps } from '@/libs/interfaceProps/customOrgProps';
import { AssetProps } from '@/libs/interfaceProps/assetProps';
import styles from './AssetBanner.module.scss';
interface AssetBannerProps {
  resourceData: AssetProps;
  customTemplate: boolean;
  customOrgIds?: CustomOrgProps;
}
const AssetBanner: React.FC<AssetBannerProps> = ({
  resourceData,
  customTemplate,
  customOrgIds
}) => {
  const [clientLogoBannerMobileSrc, setClientLogoBannerMobileSrc] = useState<string>(resourceData?.orgImages?.bannerMobile || '');
  if (resourceData?.hasOrgCustomBanner && resourceData?.orgImages?.bannerDesktop) {
    return <div className={'custom-logo-placement'}>
        <Image data-bdd={'hero-banner-image'} src={resourceData?.orgImages?.bannerDesktop} className={classNames(styles['logo-banner-img'], styles['desktop'])} priority={true} alt={'banner-background'} width={1280} height={212} unoptimized={true} />
        <Image data-bdd={'hero-banner-image'} src={clientLogoBannerMobileSrc} className={classNames(styles['logo-banner-img'], styles['mobile'])} priority={true} alt={'banner-background'} width={1280} height={300} unoptimized={true} onError={() => {
        setClientLogoBannerMobileSrc(resourceData?.orgImages?.bannerDesktop || '');
      }} />
      </div>;
  } else if (customTemplate) {
    return <div className={'custom-logo-placement'}>
        <CustomLogoRenderer templateName={customOrgIds?.customTemplateName} />
      </div>;
  }
  return null;
};
export default AssetBanner;